import { Phone, Tooltip } from "@xola/ui-kit";
import React from "react";
import { PhoneDisplay } from "@/models/DeliveryReport";

interface PhoneWithTooltipProps {
    phone: PhoneDisplay | null;
    fallback: string;
}

export const PhoneWithTooltip = ({ phone, fallback }: PhoneWithTooltipProps) => {
    if (!phone) {
        return <span>{fallback}</span>;
    }

    return (
        <Tooltip placement="top" content={phone.title}>
            <Phone>{phone.value}</Phone>
        </Tooltip>
    );
};
